export default "__VITE_ASSET__DYMAeInP__"